<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Slip Type</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="slipTypeCodes" :showDesc="false" v-model="slip_type" />
				</span>

				<em class="lt_text">Slip Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="date_from"/> ~ <CustomDatePicker v-model="date_to"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<!-- <span class="int_type sm_int">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span> -->

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
			<div class="left_option" style="margin-top:2px;">
				<item-class-select-multi-s style="display:inline-block;" ref="ItemClassSelectMultiS" :multiSelect="true" v-model="itemClasses" />
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="2%"></th>
					<th width="8%">Slip No</th>
					<th width="9%">Slip Type</th>
					<th width="8%">Slip Date</th>
					<th width="12%">Sales Group</th>
					<th width="6%">Quantity</th>
					<th width="6%">Amount</th>
					<th width="5%">Inv. Applied</th>
					<th>Description</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="slip in slips" v-bind:key="slip.slip_no">
					<td class="al_center">
						<input type="radio" v-model="selected_slip_no" :value="slip.slip_no" />
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectSlip(slip)">{{ slip.slip_dn }}</a>
					</td>
					<td class="al_center">{{ slip.slip_type_name }}</td>
					<td class="al_left">{{ slip.slip_date }}</td>
					<td class="al_left">{{ slip.sales_group_name }}</td>
					<td class="al_right">{{ slip.total_quantity | commaSeparated }}</td>
					<td class="al_right">{{ slip.total_amount | toCurrency }}</td>
					<td class="al_center">
						<span v-if="slip.inventory_applied"><font color="red">&#10004;</font></span>
					</td>

					<td class="al_left">{{ slip.description }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li v-if="selected_slip_no" class="mgr_10"><a href="javascript:void(0);" v-on:click="excel">Excel Export of Selected Slip Items(s)</a></li>
				<li v-if="modifiable"><router-link :to="{ name: 'slipDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link></li>
			</ul>
		</div>

		<table class="list_tbl mgb_0 add_top_line" v-show="false" id="exportTable">
			<thead>
				<tr>
					<th width="2%">No</th>
					<th width="10%">Class</th>
					<th>Name</th>
					<th width="15%">Color</th>
					<th width="7%">Quantity</th>
					<th width="7%">Price</th>
					<th width="7%">Amount</th>
					<th width="7%">On Hand</th>
					<th width="7%">Available</th>
					<th width="7%">On Board</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in excelItems" v-bind:key="item.slip_item_no">
					<td class="al_left">{{ index + 1 }}</td>
					<td>{{ item.class_code }}</td>
					<td class="al_left">{{ item.name }}</td>

					<td class="al_left">{{ item.color_code }}</td>
					<td class="al_right">{{ item.quantity }}</td>
					<td class="al_right">{{ item.price }}</td>
					<td class="al_right">{{ item.amount }}</td>
					<td class="al_right">{{ item.on_hand }}</td>
					<td class="al_right">
						{{ item.available_quantity }}
					</td>
					<td class="al_right">{{ item.on_board_quantity }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectSlipList, apiSelectSlip } from '@/api/purchase/slip.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
//import PartnerSelect from '@/components/common/PartnerSelect';
//import Modal from '@/components/common/Modal';
import { today, daysAgo } from '@/utils/date.js';
import XLSX from 'xlsx-js-style';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			slip_type: null,
			date_from: daysAgo(30),
			date_to: today(),
			sales_group_code: null,
			slipTypeCodes: [],
			itemClasses: [],

			keyword: null,

			salesGroups: [],

			slips: [],

			excelItems: [],

			modalName: '',
			showModal: false,

			selected_slip_no: null,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		ItemClassSelectMultiS,
	},
	methods: {
		async excel() {
			const { data } = await apiSelectSlip({
				slip_no: this.selected_slip_no,
			});
			//console.log(data);
			this.excelItems = data.slipItemList;
			this.$nextTick(() => {
				var elt = document.getElementById('exportTable');
				var wb = XLSX.utils.table_to_book(elt, { raw: false });
				return XLSX.writeFile(wb, 'Slip_ItemList_' + data.slip.slip_dn + '.xlsx', { cellDates: true });
			});
		},
		selectSlip(slip) {
			this.$router.push({ name: 'slipDetail', params: { mode: 'detail' }, query: { backUri: this.uri, slip_no: slip.slip_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectSlips(pageNo);
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			//this.invoice_type = 'S';
			this.slip_type = null;
			this.date_from = daysAgo(30);
			this.date_to = today();
			this.sales_group_code = null;
			this.keyword = null;
			this.itemClasses = [];

			//this.search();

			//this.selectInvoices();
			// this.dept_code = null;
		},
		async search() {
			await this.selectSlips();
			//if (this.invoices.length == 1 && this.keyword) this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: this.invoices[0].invoice_no } });
		},
		async selectSlips(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();
			const { data } = await apiSelectSlipList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				slip_type: this.slip_type,
				date_from: this.date_from,
				date_to: this.date_to,
				sales_group_code: this.sales_group_code,
				item_classes: this.itemClasses,
				//keyword: this.keyword,
			});

			//console.log(data);
			this.slips = data.slipList;
			this.list_count = data.list_count; //data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/purchase/slip?page_no=' + this.page_no;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.slip_type) uri += '&slip_type=' + this.slip_type;
			if (this.date_from) uri += '&date_from=' + this.date_from;
			if (this.date_to) uri += '&date_to=' + this.date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
			this.slipTypeCodes = data.slipTypeList;
		},
		async init() {
			await this.index();

			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.slip_type) this.slip_type = this.$route.query.slip_type;
			if (this.$route.query.date_from) this.date_from = this.$route.query.date_from;
			if (this.$route.query.date_to) this.date_to = this.$route.query.date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;

			await this.selectSlips(this.$route.query.page_no);
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 2);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_slip');
		this.$store.commit('setSubTitle', 'Purchase -> Slip');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
